var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 50,
    fill: "#E8F2FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.1013 49.2384C78.6787 49.8158 78.6881 50.749 78.1225 51.338L61.8669 68.2665C61.5916 68.5532 61.2138 68.7189 60.8164 68.7272L53.9688 68.8709L54.1128 62.0081C54.1209 61.6198 54.2794 61.2497 54.5548 60.9759L71.1867 44.4391C71.773 43.8561 72.7204 43.8575 73.305 44.4421L78.1013 49.2384Z",
    fill: "#2E90FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.825 42.5C62.7915 42.5 63.575 43.2835 63.575 44.25C63.575 45.2165 62.7915 46 61.825 46H49.75C47.817 46 46.25 47.567 46.25 49.5V70.5C46.25 72.433 47.817 74 49.75 74H70.75C72.683 74 74.25 72.433 74.25 70.5V61.75C74.25 60.7835 75.0335 60 76 60C76.9665 60 77.75 60.7835 77.75 61.75V70.5C77.75 74.366 74.616 77.5 70.75 77.5H49.75C45.884 77.5 42.75 74.366 42.75 70.5V49.5C42.75 45.634 45.884 42.5 49.75 42.5H61.825Z",
    fill: "#2E90FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/editProfile.90a009fa19c4f4acb82eda8595250093.svg";
export { ForwardRef as ReactComponent };